<template>
  <component :is="componentName" v-bind="{ ...$props, ...$attrs }" v-on="$listeners" />
</template>

<script>
import DefaultRow from './DefaultRowContent';
import { mapGetters } from 'vuex';

export default {
  components: {
    DefaultRow,
    SchlumCareerResponsesRow: () =>
      import(
        /* webpackChunkName: "schlum-career-response-table-header" */ '@/process/schlumberger-career/components/responses/SchlumCareerResponsesRow'
      ),

    SportmasterResponsesRow: () =>
      import(
        /* webpackChunkName: "schlum-career-response-table-header" */ '@/process/sportmaster/components/responses/SportmasterResponsesRow'
      )
  },

  computed: {
    ...mapGetters('process', ['getProcessName']),

    componentName() {
      switch (this.getProcessName) {
        case 'schlum-career':
          return 'schlum-career-responses-row';
        case 'sportmaster':
          return 'sportmaster-responses-row';
        default:
          return 'default-row';
      }
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/components/responses/RowContent.scss';

.candidate-info-item__bold {
  font-weight: bold;
}

td.column-checkbox {
  width: 50px;
  padding-left: 24px;
  box-sizing: border-box;
}

.vcv-table-row {
  height: auto;

  &:hover {
    cursor: default;
  }

  .column {
    min-height: 85px;
  }
}

.response-link {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  &:hover,
  &:focus,
  &:active {
    color: inherit;
  }
}

.responses-row {
  td.disabled {
    position: relative;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: not-allowed;
    }
  }

  [disabled] {
    opacity: 1;
  }
}

.candidate-position {
  padding-top: 0;
  font-size: 14px;
}

.candidate-info-unpaid {
  font-style: normal;
  font-weight: normal;
  line-height: 24px;
  font-size: 14px;
}

.candidate-refuse {
  line-height: 22px;
  color: #9FAAB6;
}
</style>
